<template>
  <el-dialog
    title="Agregar nueva Cuenta por cobrar"
    :visible.sync="dialogVisibility"
    @close="onDialogClose"
    :append-to-body="true"
  >
    <el-form v-model="CXCform" label-position="left">
      <el-row>
        <el-col :span="11">
          <el-form-item label="Empleado">
            <el-input
              v-model="getEmployeeName"
              size="small"
              class="inputdesc"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="Motivo">
            <el-input
              v-model="CXCform.description"
              size="small"
              class="inputdesc"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" :offset="1">
          <el-form-item label="Monto">
            <el-input-number
              v-model="CXCform.amount"
              :precision="2"
              :controls="false"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="Como descontar?: " prop="discountType">
          <el-radio-group v-model="CXCform.discountType">
            <el-radio :label="true">Quincenal</el-radio>
            <el-radio :label="false">Mensual</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="Fecha de Inicio del pago">
            <el-date-picker
              v-model="CXCform.initialDate"
              type="datetime"
              placeholder="Seleccione Fecha de Inicio"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="Meses">
            <el-input-number
              v-model="CXCform.months"
              :controls="false"
              size="small"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="Partidas">
            <el-input-number
              v-model="getPartitions"
              :controls="false"
              size="small"
              :disabled="true"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="info" @click="onDialogClose">Cancelar</el-button>
      <el-button type="primary" @click="AddCXC">Aplicar</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AddNewCXC",
  props: {
    AddCXCisVisible: {
      type: Boolean,
      default: false
    },
    EmployeeInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      CXCform: {
        description: "",
        amount: 0,
        months: 0,
        partitions: this.getPartitions,
        discountType: false,
        initialDate: ""
      }
    };
  },
  computed: {
    dialogVisibility() {
      return this.AddCXCisVisible;
    },
    getPartitions() {
      if (this.CXCform.discountType === false) {
        return this.CXCform.months * 1;
      } else if (this.CXCform.discountType === true) {
        return this.CXCform.months * 2;
      } else {
        return 0;
      }
    },
    getEmployeeName() {
      return this.EmployeeInfo.Name + " " + this.EmployeeInfo.LastName;
    }
  },
  methods: {
    onDialogClose() {
      this.$emit("onAddCXCdialogClose");
    },
    AddCXC() {
      const params = {
        EmpleadoID: this.EmployeeInfo.Id,
        Descripcion: this.CXCform.description,
        ParticionesEnmeses: this.CXCform.months,
        Monto: this.CXCform.amount,
        FechaInicio: this.CXCform.initialDate,
        IsQuincenal: this.CXCform.discountType
      };
      this.$http.post("/api/CXC/AddNewCxc", params).then(async () => {
        this.$emit("RechargeCXC");
        await this.RecalculatePayroll();
      });
    },
    async RecalculatePayroll() {
      let body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {
          this.$message.success("Cxc Agregado");
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style scoped>
.inputdesc {
  width: 75%;
}
</style>
